import {
	type COPILOT_ACTIONS,
	COPILOT_ACTION_DESCRIPTIONS,
} from "./constants/actions";

export const formatCase = (text: string, splitBy = "_", joinBy = " ") => {
	return text
		.toLowerCase()
		.split(splitBy)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(joinBy);
};

export const getCopilotAction = (
	name: (typeof COPILOT_ACTIONS)[keyof typeof COPILOT_ACTIONS],
) => {
	return {
		name,
		description: COPILOT_ACTION_DESCRIPTIONS[name],
	};
};
